import {combineReducers} from "redux";
import db from "./DataReducer";
import settings from "./SettingsReducer";

const createRootReducer = () => combineReducers({
  db,
  settings
})

export default createRootReducer;
